"use strict";
exports.__esModule = true;
exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["NOTE"] = "note";
    ActivityType["TASK"] = "task";
    ActivityType["FIELD_CHANGE"] = "field_change";
    ActivityType["CALL"] = "call";
    ActivityType["WHATSAPP"] = "whatsapp";
    ActivityType["EMAIL"] = "email";
    ActivityType["EVENT"] = "event";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
